import { baseUrl } from "./config/env";
import { findRoute } from "./config/routes";
import { renderFoxmarkLandingPage } from "./pages/foxmarkLandingPage";

export function normalizeRoutePath(pathname: string, base = "/"): string {
  let routePath = pathname || "/";
  const normalizedBase = base && base !== "/" ? `/${base.replace(/^\/|\/$/g, "")}` : "";

  if (normalizedBase && (routePath === normalizedBase || routePath.startsWith(`${normalizedBase}/`))) {
    routePath = routePath.slice(normalizedBase.length) || "/";
  }

  routePath = routePath.replace(/\/index\.html$/, "") || "/";

  return routePath.length > 1 && routePath.endsWith("/") ? routePath.slice(0, -1) : routePath;
}

export function renderFoxmarkApp(pathname: string, base = baseUrl()): string {
  const routePath = normalizeRoutePath(pathname, base);
  const route = findRoute(routePath);

  return route ? route.render(base) : renderFoxmarkLandingPage();
}
